import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { Box, Paper } from "@material-ui/core"

import HeaderRow from "./HeaderRow"
import TreeBody from "./TreeBody"
import "../../../styles/css/widgets/table.css"
import WidgetErrorFallback from "../WidgetErrorFallback"
import ErrorBoundary from "../../../pages/error/ErrorBoundary"

const Tree = ({ data, children }) => {
  const thead = _.find(children, (o) => o.type === "thead")
  const tbody = _.find(children, (o) => o.type === "tbody")

  let tr = tbody ? tbody.props.children : undefined

  if (Array.isArray(tr)) {
    ;[tr] = tr
  }
  return (
    <ErrorBoundary type="Tree" FallbackComponent={WidgetErrorFallback}>
      <Box
        component={Paper}
        elevation={0} // GAM style
        className="tree-widget"
      >
        <table className="table">
          <HeaderRow data={data} header={thead} />
          <TreeBody
            root={data.data.store.root}
            headers={data.data.columns}
            tr={tr}
          />
        </table>
      </Box>
    </ErrorBoundary>
  )
}

Tree.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

Tree.defaultProps = {
  title: undefined,
  children: undefined
}

export default Tree
